import React, { useState } from 'react'
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import TopTitleBar from '../DashBoard/ExternalDash/TopTitleBar'
import Records from './Records'
import Loader from '../../components/Loader'

const CreditLedger = () => {
    const [loading, setLoading]=useState(false)
    const [search, setSearch]=useState("")
    const Headers=["search_id","credit_earned","credit_consumed", "remaining_balance"]

    const handleSearch=(e)=>{
        setSearch(e)
    }
    
  return (
    <div className='w-100'>
        <SlideUpWrapper>
            <Loader isOpen={loading}/>
            <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'> Credit Ledger</span></h2></TopTitleBar>
            <section className="table-header6">
                        <div className="inputField2">
                            <div className="input1">
                                <div className="content1">
                                    <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                                    <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="credentials-table">
                        <Records headers={Headers}/>
                    </div>
        </SlideUpWrapper>

    </div>
  )
}

export default CreditLedger